<template>
  <div class="login">
    <!-- <u-swipe></u-swipe> -->
    <img src="@/assets/images/gia-vang-the-gioi-15-10.jpg" class="cover" />
    <div class="header">
      <u-logo class="logo" src="/images/logo.png"></u-logo>
      <div class="language" @click="goTo('/language')">
        <img src="@/assets/images/language.png" />
        <span>{{ getLangStr(locale) }}</span>
      </div>
    </div>
    <div class="form">
      <div class="form-item">
        <input :placeholder="$t('Username or phone number')" v-model="state.tel" />
      </div>
      <div class="form-item">
        <input :placeholder="$t('Please enter password')" :type="state.type" v-model="state.password" />
        <van-icon name="eye-o" class="eye" size="24" @click="open" />
      </div>
      <div class="bnts">
        <div class="bnt-login" @click="sign">
          <van-button :loading="state.loading">{{ $t("Log In") }}</van-button>
        </div>
        <div class="bnt-register">
          <van-button @click="goTo('/register')">{{
            $t("Sign Up")
            }}</van-button>
        </div>
      </div>
      <div class="href">
        <a :href="state.url">{{ $t("Forget password?") }}</a>
      </div>
      <div class="copyright">
        <img src="@/assets/images/msg6618830477-17579.jpg" /> Copyright by SJC
      </div>
    </div>
  </div>
</template>

<script setup>
import { showToast } from "vant";
import { reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { login, getCsv } from "@/api";
// import uSwipe from "./components/swipe.vue";
import uLogo from "@/components/logo";
import { getLangStr } from "@/utils";
const router = useRouter();
const { t, locale } = useI18n();
const state = reactive({
  tel: "", //13799252403
  password: "", //admin1234
  type: "password",
  loading: false,
  url: "",
});
onMounted(() => {
  getCsv().then((res) => {
    state.url = res.csv2.url;
  });
});
const goTo = (url) => {
  router.push(url);
};
const open = () => {
  state.type = state.type == "password" ? "text" : "password";
};
const sign = () => {
  if (state.tel == "" || state.password == "") {
    showToast(t("Please enter your login account and password"));
    return;
  }
  if (state.loading) {
    return;
  }
  state.loading = true;
  login({
    tel: state.tel,
    password: state.password,
  })
    .then((res) => {
      localStorage.setItem("token", res.token);

      showToast(t("Login successful"));

      setTimeout(() => {
        goTo("/");
      }, 800);
    })
    .catch((err) => {
      showToast(err.msg);
    })
    .finally(() => {
      state.loading = false;
    });
};
</script>

<style lang="less">
.login {
  min-height: 100%;
  padding-top: 1px;
  overflow-y: hidden;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 40px;
  background: #2d40e5;

  .cover {
    width: 100%;
    border: 0;
    padding: 0;
    margin: 0;
    position: relative;
    top: -2px;
  }

  .header {
    position: relative;

    .logo {
      margin: 20px auto 0 auto;
    }
  }

  .language {
    position: absolute;
    right: 0;
    top: -10px;

    display: flex;
    align-items: center;

    img {
      display: block;
      height: 16px;
      width: 16px;
    }

    span {
      padding: 0 10px 0 5px;
    }
  }

  .form {
    margin: 20px 15px 0 15px;
    padding: 12px 0;

    &-item {
      margin-bottom: 5px;
      position: relative;

      input {
        border: 1px solid rgba(0, 0, 0, 0.8);
        padding: 0 50px;
        height: 45px;

        line-height: 45px;
        box-sizing: border-box;
        display: block;
        width: 100%;
        text-align: center;
        font-size: 16px;
        margin-bottom: 15px;

        &::-webkit-input-placeholder {
          font-size: 16px;
          color: #bbb8b8;
        }

        &:focus {
          border-color: #6d00c3 !important;
          outline: none;
        }
      }

      .eye {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 24px;
      }
    }
  }

  .bnts {
    display: flex;
    justify-content: center;
  }

  .bnt-login,
  .bnt-register {
    margin: 0 30px;

    button {
      background-color: #333;
      color: #fff;

      height: 45px;
      font-size: 16px;
      display: block;
      width: 100px;
      border: none;
      border-radius: 0;
    }
  }

  .href {
    margin-top: 12px;
    line-height: 37px;
    text-align: center;

    a {
      color: #000;

      font-size: 15px;
    }
  }

  .copyright {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 14px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px;

    img {
      width: 22px;
    }
  }
}
</style>
